import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import "./BlogsAdmin.css";

const BlogsAdmin = () => {
  const [blogs, setBlogs] = useState([]);
  const [form, setForm] = useState({
    title: "",
    content: "",
    image: "",
    date: "",
    author: "",
    type: "main",
  });
  const [editId, setEditId] = useState(null);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get("https://back.varankal.com/api/blogs");
      setBlogs(res.data);
    } catch (err) {
      console.error("Error fetching blogs:", err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({ ...prev, image: file }));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", form.title);
      formData.append("content", form.content);
      formData.append("author", form.author);
      formData.append("date", form.date);
      formData.append("type", form.type);

      // ✅ Important: append file directly (not base64)
      if (form.image instanceof File) {
        formData.append("image", form.image);
      }

      if (editId) {
        await axios.put(`https://back.varankal.com/api/blogs/${editId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await axios.post("https://back.varankal.com/api/blogs", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      setForm({
        title: "",
        content: "",
        image: "",
        date: "",
        author: "",
        type: "main",
      });
      setEditId(null);
      fetchBlogs();
    } catch (err) {
      console.error("Error saving blog:", err);
    }
  };


  const handleEdit = (blog) => {
    setForm({
      title: blog.title,
      content: blog.content || "",
      image: blog.image || "",
      date: blog.date ? new Date(blog.date).toISOString().split("T")[0] : "",
      author: blog.author || "",
      type: blog.type || "main",
    });
    setEditId(blog._id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://back.varankal.com/api/blogs/${id}`);
      fetchBlogs();
    } catch (err) {
      console.error("Error deleting blog:", err);
    }
  };

  return (
    <div className="admin-wrapper99">
      <div className="admin-left99">
        <h2 className="admin-title99">📝 Manage Blogs</h2>

        <form className="admin-form99" onSubmit={handleSubmit}>
          <input
            name="title"
            placeholder="Blog Title"
            value={form.title}
            onChange={handleChange}
            required
          />
          <input
            name="author"
            placeholder="Author Name"
            value={form.author}
            onChange={handleChange}
            required
          />

          <input type="file" accept="image/*" onChange={handleImageChange} required={!editId} />
          {form.image && <img src={form.image} alt="Preview" className="image-preview99" />}

          <input name="date" type="date" value={form.date} onChange={handleChange} />

          <select name="type" value={form.type} onChange={handleChange}>
            <option value="featured">Featured</option>
            <option value="side">Side</option>
            <option value="main">Main</option>
            <option value="missed">Missed</option>
          </select>

          <textarea
            name="content"
            placeholder="Write blog content..."
            value={form.content}
            onChange={handleChange}
            rows={4}
          ></textarea>

          <button type="submit" className="submit-btn99">
            {editId ? "Update Blog" : "Add Blog"}
          </button>
        </form>
      </div>

      <div className="admin-right99">
        <h3 className="blogs-list-title99">All Blogs</h3>
        <div className="blogs-list99">
          {blogs.map((b) => (
            <div key={b._id} className="blog-card99">
              <div className="blog-content99">
                <div>
                  <h4>{b.title}</h4>
                  <p className="blog-meta99">
                    {b.author} • {b.date ? b.date.slice(0, 10) : ""}
                  </p>
                  <p className="blog-type99">Type: {b.type}</p>
                </div>
              </div>

              {b.image && <img src={b.image} alt={b.title} className="blog-thumb99" />}

              <div className="blog-actions99">
                <button onClick={() => handleEdit(b)} className="edit-btn99">
                  <FaEdit /> Edit
                </button>
                <button onClick={() => handleDelete(b._id)} className="delete-btn99">
                  <FaTrashAlt /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogsAdmin;
